export const AB_TITLE: string = 'A/B Testing';
export const APPLETS: string = 'Applets';
export const METRICS: string = 'Metrics';
export const SEASONAL: string = 'Specify period';
export const SAVE_TEST: string = 'Save Test';
// export const SEASONAL_VARIATION: string = 'Specify the period variation';
export const SEASONAL_VARIATION: string = 'Set Seasonal Duration';
export const SESSION_PER_DAY: string = 'Estimated sessions per day';
export const ORDERS_PER_DAY: string = 'Estimated orders per day';
export const TEST_DURATION: string = 'Test duration';
export const TEST_CONFIGURATION: string = 'Test configuration';
export const CALCULATE_TEST_DURATION: string = 'Calculate Test Duration';
export const RECALCULATE_TEST_DURATION: string = 'Recalculate Test Duration';
export const TEST_DESIGN: string = 'Test Design';
export const TEST_DESIGN_INFO: string = 'Choose the shopping cycle that applies to this test';
export const SCHEDULE_INFO: string = 'Based on the shopping cyclical patterns';
export const MINIMUM_LIFT_PERCENTAGE: string = 'Minimum Lift Percentage (MLP)';
export const SET_TEST_DURATION: string = 'Set Test Duration';
export const PROMOTION_PREFERENCE: string = 'Promotion preference?';
export const SCORE_WEIGHTAGE: string = 'Score Weightage';
export const TRAFFIC_DISTRIBUTION: string = 'Traffic Distribution';
export const SELECT_APPLET: string = 'Select Applet ...';
export const SELECT: string = 'Select';
export const CREATE_AB_TEST: string = 'Create A/B test';
export const TEST_NAME: string = 'Test Name';
export const DAYS: string = 'DAYS';
export const SEASON_DURATION: string = 'Select the period duration';
export const AUTO_PROMOTE: string = 'Auto Promote';
export const SCHEDULE: string = 'Schedule';
export const RUN_TEST_NOW: string = 'Run Test Now';
export const PAUSE: string = 'Pause';
export const STOP: string = 'Stop';
export const ABORT: string = 'Abort';
export const CREATED_ON: string = 'Created on';
export const CREATED_BY: string = 'Created by';
export const MODIFIED_BY: string = 'Modified by';
export const ENDED_ON: string = 'Ended on';
export const ANALYSED_DURATION: string = 'Analysed Duration';
export const ACTUAL_DURATION: string = 'Actual Duration';
export const CREATED: string = 'Created';
export const IN_PROGRESS: string = 'In Progress';
export const COMPLETED: string = 'Completed';
export const INCONCLUSIVE: string = 'Inconclusive';
export const EDIT: string = "Edit";
export const DELETE: string = "Delete";
export const GMS_AB_TESTING_CREATE: string = "gmsabtesting_create";
export const GMS_AB_TESTING_READ: string = "gmsabtesting_read";
export const GMS_AB_TESTING_UPDATE: string = "gmsabtesting_update";
export const GMS_AB_TESTING_DELETE: string = "gmsabtesting_delete";
export const DRAFT_STATUS: string = "DRAFT";
export const INITIATED_STATUS: string = "INITIATED";
export const IN_PROGRESS_STATUS: string = "IN_PROGRESS";
export const COMPLETED_STATUS: string = "COMPLETED";
export const SCHEDULED_STATUS: string = "SCHEDULED";
export const ABORTED_STATUS: string = "ABORTED";
export const DRAFT: string = "Draft";
export const INITIATED: string = "Initiated";
export const SCHEDULED: string = "Scheduled";
export const ABORTED: string = "Aborted";
export const WIN_THRESHOLD_INFO = "The minimum difference needed between value of selected metric in Control and Variant models, for a model to be declared a winner."
export const labels = ["A", "B", "C", "D"]
export const AB_TEST_RUNNING_MESSAGE = "A/B Test already running in this applet. New test will be saved as draft"
export const NORMALIZED: string = "normalized value based on session distribution";
export const NORMALIZED_NOTE: string = "*Actual traffic distribution may deviate slightly from configured percentages so the normalization is approximate";
